import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import PropTypes from "prop-types"
import queryString from "query-string"
import { withRouter } from "react-router-dom"

import UserFieldEditorContainer from "../UserFieldEditorContainer/UserFieldEditorContainer"

import {
  FormularyFooter,
  FormularyHeader,
  FormularyNavMenu,
  FormularyInputs
} from "../Formulary"

import {
  preSurveyMetadata,
  preSurveySteps
} from "../../Redux/Reducers/Application/preSurveyMetadata"
import {
  setCurrentFormulary,
  getFormularyQuestions
} from "../../Redux/Actions/Formulary/functions"

const PreSurvey = ({ history }) => {
  const dispatch = useDispatch()
  const [isInitialized, setIsInitialized] = useState(false)

  const { title: stepId } = queryString.parse(history.location.search)

  useEffect(() => {
    ;(async () => {
      const formularyType = "preSurvey"

      dispatch(setCurrentFormulary(formularyType, "Pre-Survey"))
      await dispatch(getFormularyQuestions(formularyType))

      setIsInitialized(true)
    })()
  }, [])

  return (
    <UserFieldEditorContainer
      drawerComponent={() => (
        <FormularyNavMenu
          stepId={stepId}
          formularyMetadata={preSurveyMetadata}
          title="Pre-Survey"
          steps={preSurveySteps}
        />
      )}
      initialized={isInitialized}
    >
      <FormularyHeader steps={preSurveySteps} />
      <FormularyInputs steps={preSurveySteps} />
      <FormularyFooter steps={preSurveySteps} stepId={stepId} />
    </UserFieldEditorContainer>
  )
}

PreSurvey.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({ search: PropTypes.string }),
    push: PropTypes.func
  }).isRequired
}

export default withRouter(PreSurvey)
